<template>
  <section class="relative flex w-full sidebar">
    <section
      class="overflow-y-auto transition-all duration-300 lg:w-[17%] lg:translate-x-[0] fixed left-0 h-screen z-50"
      :class="
        sidebarState ? 'translate-x-[0] w-[64%]' : '   translate-x-[-1000px]'
      "
    >
    <AutomatedSidenav/>
      <!-- <Sidebar /> -->
    </section>

    <section
      class="absolute mx-auto overflow-x-hidden lg:right-0 right-2"
      @click="(e) => closeSidebar(e)"
      :class="sidebarState ? 'lg:w-[83%] w-[95%]' : '  lg:max-w-[83%] w-[95%]'"
    >
      <slot></slot>
    </section>
  </section>
</template>

<script>
//Libraries

import { ref } from "vue";

//components
import AutomatedSidenav from "@/components/UI/AutomatedSidebar/AutomatedSidenav.vue";

export default {
  name: "MasterLayout",
  components: {
    AutomatedSidenav,
  },
  computed: {
    sidebarState() {
      return this.$store.state.sidebarState;
    },
  },
  methods: {
    closeSidebar(e) {
      const screenWidth = ref(window.innerWidth)._value;
      const targetClass = e.target.className;
      if (
        screenWidth < 1021 &&
        this.$store.state.sidebarState &&
        targetClass !== "pi pi-bars"
      ) {
        this.$store.dispatch("closeSidebar");
      }
    },
  },
};
</script>

<style></style>
